/** @jsx jsx */
import { jsx, merge, ThemeProvider } from 'theme-ui'
import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';

/** Components */
import GlobalStyles from '@components/GlobalStyles';
/** Contexts */
import theme from '../theme'

const query = graphql`
  {
    settings {
      colors {
        background
        black
        grey
        primary
        published
        secondary
        text
        white
      }
    }
  }
`

export default function ColorThemeProvider({ children }) {
  const { settings: { colors } } = useStaticQuery(query);

  const themeColors = {
    background: `rgba(${colors?.background || theme?.colors?.background})`,
    black: `rgba(${colors?.black || theme?.colors?.black})`,
    border: `rgba(216, 216, 216)`,
    borderSocial: `rgba(189, 189, 189, 1)`,
    error: `rgba(236,38,38,1)`,
    faded: `rgba(${colors?.black || theme?.colors?.black}, 0.5)`,
    grey: `rgba(${colors?.grey || theme?.colors?.grey})`,
    highlight: {
      dark: `rgba(${colors?.primary || theme?.colors?.primary}, 0.60)`,
      light: `rgba(${colors?.primary || theme?.colors?.primary}, 0.25)`,
    },
    hover: `rgba(${colors?.primary || theme?.colors?.primary}, 0.1)`,
    overlay: `rgba(${colors?.black || theme?.colors?.black}, 0.35)`,
    primary: `rgba(${colors?.primary || theme?.colors?.primary})`,
    published: `rgba(${colors?.published || theme?.colors?.published})`,
    secondary: `rgba(${colors?.secondary || theme?.colors?.secondary})`,
    text: `rgba(${colors?.text || theme?.colors?.text})`,
    white: `rgba(${colors?.white || theme?.colors?.white})`,
  };

  const mergedColors = merge(theme.colors, themeColors)
  theme.colors = mergedColors

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles colors={theme.colors} />
      {children}
    </ThemeProvider>
  );
}

ColorThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
